module.exports = __webpack_public_path__ + "img/logo-topnav-light.aa76cd79.svg";